import { GlobalAxios } from "../axios/axios-config";
import { ISolvedExamFilesLog } from "../models/exam-files-log";

const EXAM_FILES_LOG_ROUTE =
  process.env.REACT_APP_4UBUS + "/api/v1/ForuBusExamFilesLog";

export const solvedExam = ({
  identifier,
  item,
}: {
  identifier: number;
  item: ISolvedExamFilesLog;
}) => {
  return GlobalAxios.put(`${EXAM_FILES_LOG_ROUTE}/${identifier}`, item);
};
